import { Col, Row } from 'antd'
import React, { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom';



const FooterFile = () => {
  const [isMobile, setIsMobile] = useState(window.innerWidth);

  const navigate = useNavigate();

    useEffect(() => {
      const handleResize = () => {
        setIsMobile(window.innerWidth < 770); // Set breakpoint for mobile
      };
  
      handleResize(); // Set initial state
      window.addEventListener("resize", handleResize);
  
      return () => {
        window.removeEventListener("resize", handleResize);
      };
    }, []);
  
  return (
    
    < >
              <div
                style={{
                  backgroundImage: "url('/follow-bg.png')",
                  backgroundSize: "cover",
                  backgroundPosition: "center",
                  backgroundRepeat: "no-repeat",
                  width: "100%",
                  height: "auto",
                  padding: "0 5%"
                }}
              >
                <Row style={{ paddingTop: "10px" }}>
  <Col xs={24} md={24}>
    <div style={{ textAlign: "left" }}>
      
      {/* Wave Icon */}
     

      {/* Text */}
     

      {/* Social Icons */}
     

    </div>
  </Col>
</Row>
                   <div className='footer-style'>
     {isMobile && (
         <div style={{color:"white"}}>
          <img
            src="../logo.png"
            alt="Logo"
            style={{ height: "35px"}}
          />
         
          <h3 style={{margin:"15px 0 0", fontSize:"20px", color:"#ffa321"}}> Follow for latest updates</h3>

          <div className='footer-talk'>
            <div className='footer-center'>
          
           <div className="follow-container" style={{ display: "flex", gap: "10px" }}>
        
        <a href="https://www.instagram.com/rucksackdiaries/" target="_blank" rel="noopener noreferrer">
          <div className="follow-style">
            <img src="/instagram.svg" alt="Instagram" className="follow-img" />
          </div>
        </a>

        <a href="https://www.youtube.com/@mounananaiah" target="_blank" rel="noopener noreferrer">
          <div className="follow-style">
            <img src="/youtube.svg" alt="YouTube" className="follow-img" />
          </div>
        </a>

        <a href="https://www.linkedin.com/in/mouna-nanaiah-b9902ab6/" target="_blank" rel="noopener noreferrer">
          <div className="follow-style">
            <img
              src="/linkedin.svg"
              alt="LinkedIn"
              className="follow-imgv2"/>
          </div>
        </a>

      </div>
            </div>
           
          </div>
          

          <Row justify="center" align="middle" style={{marginTop:"1rem"}}>
        <Col span={12}>
        <div className='footer-nav'>
         
            <a href="https://blog.rucksackdiaries.com/faq/"  rel="noopener noreferrer"> <ul>FAQ </ul></a>
           <a href="https://blog.rucksackdiaries.com/terms-conditions/"  rel="noopener noreferrer"> <ul>Terms & Conditions</ul></a>
            <a href="https://blog.rucksackdiaries.com/privacy-policy/"  rel="noopener noreferrer"> <ul>Privacy Policy</ul></a>
          
          </div>
        </Col>
        
        </Row>
       
        <p className='fter_text' style={{paddingTop:"2rem", fontWeight:"bold", textAlign:"center"}}>
          © {new Date().getFullYear()} Mouna Nanaiah All Rights Reserved.
        </p>

        <p className='fter_text' style={{textAlign:"center"}}>
          Designed and developed by <b><a href='https://www.kavintech.com'>KavinTech Corporation</a>
        </b></p>
      </div>
    )}

    {!isMobile && (
      <>
        <Row className='footerbtmgrid' justify="center" align="top">
        <Col span={8}>
          <img
            src="../logo.png"
            alt="Logo"
            style={{ height: "30px"}}
          />        
       
        </Col>

        <Col span={8}>
          <div className='footer-nav'>            
            <a href="https://blog.rucksackdiaries.com/faq/"  rel="noopener noreferrer"> <ul>FAQ</ul></a>
            <a href="https://blog.rucksackdiaries.com/terms-conditions/"  rel="noopener noreferrer"> <ul>Terms & Conditions</ul></a>
            <a href="https://blog.rucksackdiaries.com/privacy-policy/"  rel="noopener noreferrer"> <ul>Privacy Policy</ul></a>           
          </div>
        </Col>

        <Col span={8}>
        <div style={{color: "#fff"}}>
          <h1 style={{margin:0, fontSize:"20px", color:"#ffa321",}}>Follow for latest updates</h1>
          <div className='footer-talk'>
            <div className='footer-center'>
           <div className="follow-container" style={{ display: "flex", gap: "10px" }}>        
        <a href="https://www.instagram.com/rucksackdiaries/" target="_blank" rel="noopener noreferrer">
          <div className="follow-style">
            <img src="/instagram.svg" alt="Instagram" className="follow-img" />
          </div>
        </a>

        <a href="https://www.youtube.com/@mounananaiah" target="_blank" rel="noopener noreferrer">
          <div className="follow-style">
            <img src="/youtube.svg" alt="YouTube" className="follow-img" />
          </div>
        </a>

        <a href="https://www.linkedin.com/in/mouna-nanaiah-b9902ab6/" target="_blank" rel="noopener noreferrer">
          <div className="follow-style">
            <img
              src="/linkedin.svg"
              alt="LinkedIn"
              className="follow-imgv2"/>
          </div>
        </a>

      </div>
            </div>

            
          </div>
          
        </div>
        </Col>
      </Row>

      <span style={{display:"flex", justifyContent:"space-between", color:"black"}}>
        <p style={{paddingTop:"2rem", fontSize:"13px", fontWeight:"600"}}>
          © {new Date().getFullYear()} Mouna Nanaiah All Rights Reserved.
        </p>
        <p style={{textAlign:"end", paddingTop:"2rem"}}>
          Designed and developed by <b style={{fontWeight:"600"}}><a href='https://www.kavintech.com'>KavinTech Corporation</a>
        </b></p>
      </span>
      </>
    )}
    </div>
  </div>                               
    </>
  )
}

export default FooterFile